import { useEffect, useState } from "react";
import { getTrip } from "../../../store/reducers/home/apiThunk";
import { useDispatch, useSelector } from "react-redux";

const useCreateTrip = (showCreateTrip, isDiscardModalOpen, setTripDetails) => {
    const [loadingTripDetails, setLoading] = useState(false);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const dispatch = useDispatch();
    const authentication = useSelector((state) => state.authentication);

    const fetchTripDetails = async () => {
        setLoading(true)
        try {
          const response = await dispatch(getTrip());
            setTripDetails(response?.payload?.data[0]);
            if(!!response?.payload?.data?.[0]?.arrival_date?.length && !!response?.payload?.data?.[0]?.city_name?.length && !!response?.payload?.data?.[0]?.hotel_name?.length)
                setSelectedTrip(response?.payload?.data?.[0]?.id)
            else 
                setSelectedTrip(null)
        } catch (error) {
          console.error("Error fetching trip details:", error);
        } finally {
            setLoading(false)
        }
    };

    const guestUserSessionKey = localStorage.getItem("guestUserSessionKey");
    useEffect(() => {
        const auth_token =
        authentication?.auth?.data?.auth_token ||
        authentication?.auth?.data?.data?.auth_token ||
        authentication?.userData?.data?.auth_token ||
        "";
        if(!auth_token){
            if((!showCreateTrip || !isDiscardModalOpen) && guestUserSessionKey){
                fetchTripDetails();
            }
        } else {
            if((!showCreateTrip || !isDiscardModalOpen)){
                fetchTripDetails();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showCreateTrip, isDiscardModalOpen, guestUserSessionKey]);
    
    return { 
        loadingTripDetails,
        selectedTrip,
        setSelectedTrip
    };
}

export default useCreateTrip;